// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"aee005a1","409":"1d2eb829","689":"dc8d5acf","849":"44e928d0"}[chunkId] + ".chunk.js";
};